import handler from 'api/handler'

const prefix = '/public/matrimonial'

const methods = {
  create: args => handler({ method: 'post', url: `${prefix}/create`, args }),
  search: args => handler({ method: 'post', url: `${prefix}/search`, args }),
  getMatrimonialProfiles: args => handler({ method: 'get', url: prefix, params: args }),
  getMatrimonialProfileById: id => handler({ method: 'get', url: `${prefix}/${id}` }),
  update: (id, args) => handler({ method: 'put', url: `${prefix}/update/${id}`, args }),
  delete: id => handler({ method: 'delete', url: `${prefix}/delete`, args: { id } }),
  addReference: args => handler({ method: 'post', url: `${prefix}/addReference`, args })

}

export default methods
